import { render, staticRenderFns } from "./Teacher Edit.vue?vue&type=template&id=0c3afdf0&scoped=true&"
import script from "./Teacher Edit.vue?vue&type=script&lang=js&"
export * from "./Teacher Edit.vue?vue&type=script&lang=js&"
import style0 from "./Teacher Edit.vue?vue&type=style&index=0&id=0c3afdf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3afdf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDialog,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
